module.exports = __webpack_public_path__ + "img/hint.464093af.png";